export function getPreselectedTab(tabs, category) {
    return tabs.find((tab) => tab.type === category);
}
